/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListPostsInAThread200ResponseMeta } from './ListPostsInAThread200ResponseMeta';
import {
    ListPostsInAThread200ResponseMetaFromJSON,
    ListPostsInAThread200ResponseMetaFromJSONTyped,
    ListPostsInAThread200ResponseMetaToJSON,
    ListPostsInAThread200ResponseMetaToJSONTyped,
} from './ListPostsInAThread200ResponseMeta';
import type { ListPostsInAThread200ResponseLinks } from './ListPostsInAThread200ResponseLinks';
import {
    ListPostsInAThread200ResponseLinksFromJSON,
    ListPostsInAThread200ResponseLinksFromJSONTyped,
    ListPostsInAThread200ResponseLinksToJSON,
    ListPostsInAThread200ResponseLinksToJSONTyped,
} from './ListPostsInAThread200ResponseLinks';
import type { ShowThread200ResponseDataPostsInner } from './ShowThread200ResponseDataPostsInner';
import {
    ShowThread200ResponseDataPostsInnerFromJSON,
    ShowThread200ResponseDataPostsInnerFromJSONTyped,
    ShowThread200ResponseDataPostsInnerToJSON,
    ShowThread200ResponseDataPostsInnerToJSONTyped,
} from './ShowThread200ResponseDataPostsInner';

/**
 * 
 * @export
 * @interface ListPostsInAThread200Response
 */
export interface ListPostsInAThread200Response {
    /**
     * 
     * @type {Array<ShowThread200ResponseDataPostsInner>}
     * @memberof ListPostsInAThread200Response
     */
    data?: Array<ShowThread200ResponseDataPostsInner>;
    /**
     * 
     * @type {ListPostsInAThread200ResponseLinks}
     * @memberof ListPostsInAThread200Response
     */
    links?: ListPostsInAThread200ResponseLinks;
    /**
     * 
     * @type {ListPostsInAThread200ResponseMeta}
     * @memberof ListPostsInAThread200Response
     */
    meta?: ListPostsInAThread200ResponseMeta;
}

/**
 * Check if a given object implements the ListPostsInAThread200Response interface.
 */
export function instanceOfListPostsInAThread200Response(value: object): value is ListPostsInAThread200Response {
    return true;
}

export function ListPostsInAThread200ResponseFromJSON(json: any): ListPostsInAThread200Response {
    return ListPostsInAThread200ResponseFromJSONTyped(json, false);
}

export function ListPostsInAThread200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPostsInAThread200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ShowThread200ResponseDataPostsInnerFromJSON)),
        'links': json['links'] == null ? undefined : ListPostsInAThread200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListPostsInAThread200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListPostsInAThread200ResponseToJSON(json: any): ListPostsInAThread200Response {
    return ListPostsInAThread200ResponseToJSONTyped(json, false);
}

export function ListPostsInAThread200ResponseToJSONTyped(value?: ListPostsInAThread200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ShowThread200ResponseDataPostsInnerToJSON)),
        'links': ListPostsInAThread200ResponseLinksToJSON(value['links']),
        'meta': ListPostsInAThread200ResponseMetaToJSON(value['meta']),
    };
}

